<template>
    <div class="wrapper d-flex p-3">
        <div class="panel mx-4 my-auto d-flex p-3" @click="go()">
        <div class="flex-column d-flex m-auto">
            <img :src="require('@/assets/' + 'imgs/' + img)" alt="">
            <div class="p-2">{{text}}</div></div>
    </div>

    </div>
</template>


<script>
export default {
    name : 'panel',
    props : ['url', 'text', 'img'],
    methods:{
        go : function()
        {
           
            this.$router.push({path: this.$props.url})
        }
    }
    

}
</script>

<style>
.wrapper {
    
    
    overflow: hidden!important;

}
.panel {
     box-shadow: 0px 0px 8px 1px rgba(0,0,0,0.28);
    width: 300px;
    height: 200px;
    cursor: pointer;
    transform: scale(1.0);
    
    transition-duration: 0.5s;
    
    background-color: #FCD0BA;
}
img {
    object-fit: contain
}
.panel:hover{
    transform: scale(1.1);
    background-color:crimson ;
    
    transition-duration: 0.5s;
}

</style>